<template>
	<v-row justify="center" no-gutters v-if="Boolean(person)">
		<avatar
			style="position: absolute; left: 50%; transform: translate(-50%, -70px); z-index: 1;"
			:headline="false"
			class="mr-2 hidden-sm-and-down"
			size="100"
			icon
			:name="person.firstName"
			:last-name="person.lastName"
			:url="person.avatar"
		/>
		<div class="headline text--secondary text-capitalize mt-7">
			<avatar
				:headline="false"
				class="mr-2 hidden-md-and-up"
				size="35"
				icon
				:name="person.firstName"
				:last-name="person.lastName"
				:url="person.avatar"
			/>
			{{ person.firstName }} {{ person.lastName && person.lastName }}
		</div>
		<v-col v-if="person" cols="12" class="mt-8">
			<v-divider></v-divider>
			<v-tabs v-model="tab">
				<v-tab class="overline">Datos personales</v-tab>
				<v-tab class="overline"> Documentos</v-tab>
				<v-tab class="overline">Ubicación</v-tab>
				<v-tab class="overline">Jornada</v-tab>
				<v-tab v-show="person.isUser && !isShared" class="overline">
					<v-badge :content="notified" :value="notified" color="accent">
						Chat
					</v-badge>
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab">
				<v-tab-item>
					<v-card outlined>
						<v-card-text>
							<personal-data
								:person-props="person"
								:create="create"
								:isInvite="isInvite"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-card outlined>
						<v-card-text>
							<person-documents :person="person" />
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-card outlined>
						<v-card-text>
							<contact :person-props="person" />
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-card outlined>
						<v-card-text>
							<role :person-props="person" />
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item v-if="person.isUser">
					<messages
						:id="person._id"
						:sender="userProfile.name"
						:conversations="person.conversation"
						:receiver="person._id"
					/>
				</v-tab-item>
			</v-tabs-items>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	name: 'TabsPerson',
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
		PersonalData: () => import('@/components/persons/PersonalData'),
		Contact: () => import('@/components/persons/Contact'),
		Role: () => import('@/components/persons/Role'),
		Messages: () => import('@/components/persons/Messages'),
		PersonDocuments: () => import('@/components/persons/PersonDocuments'),
	},
	props: {
		isInvite: {
			type: Boolean,
			default: false,
		},
		create: {
			type: Boolean,
			default: false,
		},
		isShared: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tab: 0,
		};
	},
	computed: {
		...mapGetters({
			person: 'Person/person',
			notified: 'Person/notified',
		}),
	},
	methods: {
		async putConversation() {
			if (this.person.conversation.length) {
				const person = await this.updateConversation({
					id: this.person._id,
					payload: { read: true, receiver: this.userProfile._id },
				});
				this.setPersons(person);
			}
		},
		...mapMutations({
			setPersons: 'Person/setPersons',
		}),
		...mapActions({
			updateConversation: 'Person/updateConversation',
			getPerson: 'Person/getPerson',
		}),
	},
	watch: {
		tab() {
			if (this.tab == 4 && this.notified) {
				this.putConversation();
			}
		},
		person(newValue) {
			if (this.tab == 4 && this.notified) {
				this.putConversation();
			}
			if (!newValue) {
				this.tab = 0;
			}
		},
	},
};
</script>
